import styled from "@emotion/styled";
import { CalendarGridBody } from "react-aria-components";

export const StyledCalendarGridBody = styled(CalendarGridBody)``;
